module.exports = __webpack_public_path__ + "static/media/countingwell-logo.0d66ce90.png";